
export default {
    getCurrentOrgGuid(context) {
        let guid = context.rootGetters['auth/getOrgUid']
        if(this.isMapExampleRouteByContext(context)) {
            guid = this.getMapExampleOrgGuid()
        }
        return guid
    },
    isMapExampleRouteByContext(context) {
        const route = context.rootState.route
        return this.isMapExampleRoute(route)
    },
    isMapExampleRoute(route) {
        return route.name == 'MapDashboard-Example'
    },
    getMapExampleOrgGuid() {
        return "b9dc5b89-bd65-47f2-9b35-4ba55c4c33fd"
    },
    getMapExampleAdditionHeaders(context) {
        if(this.isMapExampleRouteByContext(context)) {
            return {'mex': 'b9dc5b89-bd65-47f2-9b35-4ba55c4c33fd',}
        } else {
            return {}
        }
    },
};
